<template>
    <md-dialog :md-active.sync="showDialog"
               :md-click-outside-to-close="false"
               :md-fullscreen="true"
               @md-opened="onOpened">
        <md-dialog-title>Matrículas</md-dialog-title>

        <md-dialog-content>
            <md-table class="krt-table"
                      v-model="matriculas"
                      md-sort="descricacaoEspecialidade"
                      md-sort-order="asc">
                <md-table-row slot="md-table-row" slot-scope="{ item }" @click.native="$emit('click', item)">
                    <md-table-cell md-label="RA" md-sort-by="codigoAluno" md-numeric>{{ item.codigoAluno }}{{item.codigoEspecialidade }}</md-table-cell>
                    <md-table-cell md-label="Especialidade" md-sort-by="descricacaoEspecialidade">{{ item.descricacaoEspecialidade }}</md-table-cell>
                    <md-table-cell md-label="Turno" md-sort-by="descricaoTurno">{{ item.descricaoTurno }}</md-table-cell>
                    <md-table-cell md-label="Situacao" md-sort-by="situacaoAtual">
                        <LabelSituacaoAcademica :codigo="item.codigoSituacaoAtual" :descricao="item.situacaoAtual" />
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </md-dialog-content>

        <md-dialog-actions>
            <md-button class="md-primary" @click="$emit('closed')">Sair</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import LabelSituacaoAcademica from '@/components/LabelSituacaoAcademica.vue'

    export default {
        name: 'ModalMatriculas',
        components: {
            LabelSituacaoAcademica
        },
        props: {
            showDialog: Boolean
        },
        data() {
            return {
                matriculas: []
            }
        },
        methods: {
            onOpened() {
                if (sessionStorage.Matriculas) {
                    this.matriculas = JSON.parse(sessionStorage.Matriculas);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .md-table {
        height: 100% !important;
    }

    /*.md-table {
        border-collapse: separate !important;
        border-spacing: 0 !important;
        background-color: #ff0000;
    }*/

    tr td:first-child {
        border-left: solid 5px #000;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    tr.default td:first-child {
        border-left-color: #EEF2F6;
    }

    tr.primary td:first-child {
        border-left-color: #6361FB;
    }

    tr.success td:first-child {
        border-left-color: #009688;
    }

    tr.danger td:first-child {
        border-left-color: #FF0000;
    }

    tr.warning td:first-child {
        border-left-color: #FFB300;
    }
</style>
